import { render, staticRenderFns } from "./PassageEditor.vue?vue&type=template&id=481cb663"
import script from "./PassageEditor.vue?vue&type=script&lang=ts"
export * from "./PassageEditor.vue?vue&type=script&lang=ts"
import style0 from "./PassageEditor.vue?vue&type=style&index=0&id=481cb663&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports